import React, { Component } from 'react'
import { connect } from 'shalala';
import { Dropdown, Button } from 'react-bootstrap';

import { useStore } from '../../../../store';
import CustomDropdownToggle from '../../../../facturotopia/CustomDropdownToggle';

class TimbradoMasivoTicketsFilters extends Component {

  state = {};
  timerId = null;

  handleOnSelectComprobanteFilter = (name, filter) => {
    this.setState({
      [name]: filter !== '' ? filter : ''
    });

    if (this.timerId) {
      clearTimeout(this.timerId);
    }

    this.timerId = setTimeout(() => {
      this.submit();
    }, 5000);
  }

  submit = () => {
    if (this.timerId) {
      clearTimeout(this.timerId);
    }

    const { filters } = this.props;

    this.props.paginate({
      ...filters,
      ...this.state
    });
  }

  getTypeLegend = () => {
    const { type } = this.state;
    let legend = "";

    switch (type) {
      case "I":
        legend = "Ingreso"
        break;
      case "E":
        legend = "Egreso"
        break;
      case "T":
        legend = "Traslado"
        break;
      case "P":
        legend = "Pago"
        break;
      case "N":
        legend = "Nomina"
        break;
      default:
        break;
    }

    return legend;
  }

  getStatusLegend = () => {
    const { status } = this.state;
    let legend = "";

    switch (status) {
      case "0":
        legend = "Pendientes"
        break;
      case "1":
        legend = "Timbrados"
        break;
      case "-1":
        legend = "Cancelados"
        break;
      case "-2":
        legend = "Errores"
        break;
      case "-3":
        legend = "Fallidos"
        break;
      case "2":
        legend = "En proceso"
        break;
      case "3":
        legend = "Duplicados"
        break;

      default:
        break;
    }

    return legend;
  }

  render() {
    return (
      <div className="mb-1 float-left">
        <Dropdown onSelect={ this.handleOnSelectComprobanteFilter.bind(this, 'type') } className="float-left mr-1 pb-2">
          <Dropdown.Toggle as={ CustomDropdownToggle }>
            { this.getTypeLegend() || 'Tipo' }
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item eventKey="">Todos</Dropdown.Item>
            <Dropdown.Item eventKey="I">Ingreso</Dropdown.Item>
            <Dropdown.Item eventKey="E">Egreso</Dropdown.Item>
            <Dropdown.Item eventKey="T">Traslado</Dropdown.Item>
            <Dropdown.Item eventKey="P">Pago</Dropdown.Item>
            <Dropdown.Item eventKey="N">Nomina</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>

        <Dropdown onSelect={ this.handleOnSelectComprobanteFilter.bind(this, 'status') } className="float-left mr-1 pb-2">
          <Dropdown.Toggle as={ CustomDropdownToggle }>
          { this.getStatusLegend() || 'Status' }
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item eventKey="">Todos</Dropdown.Item>
            <Dropdown.Item eventKey="0">Pendientes</Dropdown.Item>
            <Dropdown.Item eventKey="1">Timbrados</Dropdown.Item>
            <Dropdown.Item eventKey="-1">Cancelados</Dropdown.Item>
            <Dropdown.Item eventKey="-2">Errores</Dropdown.Item>
            <Dropdown.Item eventKey="-3">Fallidos</Dropdown.Item>
            <Dropdown.Item eventKey="2">En proceso</Dropdown.Item>
            <Dropdown.Item eventKey="3">Duplicados</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>

        <Button variant="secondary" className="text-muted float-xs-right float-sm-right float-md-left" onClick={ this.submit }>
          Aplicar
        </Button>
      </div>
    )
  }
}

const mapState = (store) => {
  return store.modulo.timbrado_masivo.tickets
};

const mapActions = (actions) => {
  return actions.modulo.timbrado_masivo.tickets;
};

export default connect(useStore, mapState, mapActions)(TimbradoMasivoTicketsFilters);